import React from 'react'

export default function HowItWork() {
    return (
        <div className='relative mt-10'>
            <img src="/images/how-it-work.png" alt="" className='w-full md:block hidden animate__fadeInUp wow animate__animated' />
            <img src="/images/line.png" alt="" className=' md:hidden block w-[28vw] ' />
            <img src="/images/chinu.png" alt="" className='absolute md:left-0 left-2 md:w-[30vw] w-[90vw] md:top-[28vw] top-[160vw] animate__jello  wow animate__animated animate__infinite custom-duration' />
            <div className='absolute z-50 top-12 left-[80px] md:hidden flex flex-col gap-8 pr-5'>
                <div className='flex items-start gap-5'>
                    <div>
                        <div className='w-10 h-10 font-bold flex items-center justify-center rounded-full bg-black border-2 border-[#FFF200] animate__fadeInUp wow animate__animated '>
                            <h1>01</h1>
                        </div>
                    </div>
                    <div className='animate__fadeInUp wow animate__animated '>
                        <h2 className='font-bold'>Define Your Brand Persona</h2>
                        <p className='text-gray-400'>Tell Chinu AI about your tone, style, & key topics.</p>
                    </div>
                </div>
                <div className='flex items-start gap-5'>
                    <div>
                        <div className='w-10 h-10 font-bold flex items-center justify-center rounded-full bg-black border-2 border-[#FFF200] animate__fadeInUp wow animate__animated animate__delay-1s'>
                            <h1>02</h1>
                        </div>
                    </div>
                    <div className='animate__fadeInUp wow animate__animated animate__delay-1s'>
                        <h2 className='font-bold'>Generate Bulk Tweets</h2>
                        <p className='text-gray-400'>Let the AI produce multiple tweet ideas at once. Approve, reject, or edit to further train the model.</p>
                    </div>
                </div>
                <div className='flex items-start gap-5'>
                    <div>
                        <div className='w-10 h-10 font-bold flex items-center justify-center rounded-full bg-black border-2 border-[#FFF200] animate__fadeInUp wow animate__animated animate__delay-2s'>
                            <h1>03</h1>
                        </div>
                    </div>
                    <div className='animate__fadeInUp wow animate__animated animate__delay-2s'>
                        <h2 className='font-bold'>Enhance with AI-Generated Media</h2>
                        <p className='text-gray-400'>Automatically create visuals or short videos that complement your tweets..</p>
                    </div>
                </div>
                <div className='flex items-start gap-5'>
                    <div>
                        <div className='w-10 h-10 font-bold flex items-center justify-center rounded-full bg-black border-2 border-[#FFF200] animate__fadeInUp wow animate__animated animate__delay-3s'>
                            <h1>04</h1>
                        </div>
                    </div>
                    <div className='animate__fadeInUp wow animate__animated animate__delay-3s'>
                        <h2 className='font-bold'>Schedule & Automate</h2>
                        <p className='text-gray-400'>Post tweets at optimal times—fully automated or with manual sign-off.</p>
                    </div>
                </div>
                <div className='flex items-start gap-5'>
                    <div>
                        <div className='w-10 h-10 font-bold flex items-center justify-center rounded-full bg-black border-2 border-[#FFF200] animate__fadeInUp wow animate__animated animate__delay-4s'>
                            <h1>05</h1>
                        </div>
                    </div>
                    <div className='animate__fadeInUp wow animate__animated animate__delay-4s'>
                        <h2 className='font-bold'>Engage in Real Time</h2>
                        <p className='text-gray-400'>The AI monitors your mentions & replies 24/7, keeping your audience connected & appreciated.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
